import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/icons/icon';
import { Typography } from '../../../components/typography/typography';
import '../admin-user.scss';
import { useAdmin } from '../../../hooks/use-admin-context';
import { Card } from '../../../components/card/card';
import { PasswordChangeForm } from '../components/password-change-form';

export function formatAdmin({
  id,
  email,
  username,
  name,
  isSuperAdmin,
}: {
  id: number;
  email: string;
  username: string;
  name: string;
  isSuperAdmin: boolean;
}) {
  return {
    adminId: id,
    adminEmail: email,
    adminUsername: username,
    adminFullName: name,
    adminIsSuperAdmin: isSuperAdmin ? 1 : 0,
  };
}

export const AdminChangePassword = () => {
  const { id, name, username, email, isSuperAdmin } = useAdmin();
  const navigate = useNavigate();

  return (
    <div className="admin-user">
      <div className="container-v2">
        <div className="flex items-center gap-2 mb-5">
          <div className="cursor-pointer" onClick={() => navigate(-1)} data-cy="back-button">
            <Icon icon="Back" size="large" />
          </div>
          <Typography type="display-sm" weight="medium">
            Change Password
          </Typography>
        </div>

        <Card>
          <PasswordChangeForm
            admin={formatAdmin({ id, email, username, name, isSuperAdmin })}
            showCurrentPassword={true}
          />
        </Card>
      </div>
    </div>
  );
};
